/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import Typography from "@mui/material/Typography";
import {
  RS_ADDRESS,
  RS_ADDRESS_LOCALITY,
  RS_NAME,
  RS_POSTAL_CODE,
  SERVICE_EMAIL,
  SERVICE_PHONE,
} from "../../services/globalVars";

export default function Imprint() {
  return (
    <div id="impressum">
      <Typography variant={"h1"}>Impressum</Typography>
      <Typography variant={"h3"}>Legalbird.io ist ein Angebot der Legalbird GmbH</Typography>
      <p>
        <b>Angaben gemäß § 5 TMG und verantwortlich gemäß § 55 Abs. 2 RStV</b>
        <br />
        Andreas Quauke
        <br />
        {RS_NAME}
        <br />
        {RS_ADDRESS}
        <br />
        {RS_POSTAL_CODE} {RS_ADDRESS_LOCALITY}
        <br />
        <br />
        <b>Geschäftsführer</b>
        <br />
        Andreas Quauke, Melanie Treude
        <br />
        <br />
        <b>Kontakt</b>
        <br />
        Kundenservice: <a href={"mailto:" + SERVICE_EMAIL}>{SERVICE_EMAIL}</a>
        <br />
        Geschäftliche / rechtliche Anfragen: <a href={"mailto:" + SERVICE_EMAIL}>{SERVICE_EMAIL}</a>
        <br />
        Tel.: {SERVICE_PHONE}
        <br />
        <br />
        Eingetragen beim Amtsgericht Köln
        <br />
        HRB 93096 | USt-ID DE 318424936
        <br />
        <br />
        <b>Hinweis auf EU-Streitschlichtung</b>
        <br />
        Die europäische Webseite für Online-Schlichtungen ist:
        <a href="http://ec.europa.eu/consumers/odr/"> http://ec.europa.eu/consumers/odr/</a> <br />
        Wir sind zur Teilnahme an der Streitschlichtung weder verpflichtet, noch nehmen wir hieran freiwillig teil.
        <br />
        <br />
        <b>Datenschutz</b>
        <br />
        Die Datenschutzerklärung der Legalbird GmbH finden Sie
        <Link to={"/datenschutz"}> hier</Link>.
      </p>
    </div>
  );
}
